var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 12.0007V28.0006H1.33337V12.0007H6.66671ZM12 28.0006C11.2928 28.0006 10.6145 27.7197 10.1144 27.2196C9.61433 26.7195 9.33337 26.0412 9.33337 25.334V12.0007C9.33337 11.2673 9.62671 10.6007 10.12 10.1207L18.8934 1.33398L20.3067 2.74732C20.6667 3.10732 20.8934 3.60065 20.8934 4.14732L20.8534 4.57398L19.5867 10.6673H28C28.7073 10.6673 29.3856 10.9483 29.8857 11.4484C30.3858 11.9485 30.6667 12.6267 30.6667 13.334V16.0007C30.6667 16.3473 30.6 16.6673 30.48 16.974L26.4534 26.374C26.0534 27.334 25.1067 28.0006 24 28.0006H12ZM12 25.334H24.04L28 16.0007V13.334H16.28L17.7867 6.24065L12 12.0407V25.334Z",
    fill: "inher"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 13.334C30.6667 12.6267 30.3858 11.9485 29.8857 11.4484C29.3856 10.9483 28.7073 10.6673 28 10.6673H19.5734L20.8534 4.57398C20.88 4.44065 20.8934 4.29398 20.8934 4.14732C20.8934 3.60065 20.6667 3.09398 20.3067 2.73398L18.8934 1.33398L10.12 10.1073C9.62671 10.6007 9.33337 11.2673 9.33337 12.0007V25.334C9.33337 26.0412 9.61433 26.7195 10.1144 27.2196C10.6145 27.7197 11.2928 28.0006 12 28.0006H24C25.1067 28.0006 26.0534 27.334 26.4534 26.374L30.48 16.974C30.6 16.6673 30.6667 16.3473 30.6667 16.0007V13.334ZM1.33337 28.0006H6.66671V12.0007H1.33337V28.0006Z",
    fill: "#008BFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledLike);
export default __webpack_public_path__ + "static/media/FilledLike.179300b5a2e7168f204620639343c8b6.svg";
export { ForwardRef as ReactComponent };